var SpriteSymbol = require("../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "important",
  "use": "important-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\" id=\"important\">\n    <path d=\"M23.98 4C12.94 4 4 12.96 4 24C4 35.04 12.94 44 23.98 44C35.04 44 44 35.04 44 24C44 12.96 35.04 4 23.98 4ZM24 40C15.16 40 8 32.84 8 24C8 15.16 15.16 8 24 8C32.84 8 40 15.16 40 24C40 32.84 32.84 40 24 40ZM22 30H26V34H22V30ZM22 14H26V26H22V14Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol